const ExceptionCodes: ECode = {
  '101': 'Unknown error',
  '201': 'Error fetching cart data from the UUAPI',
  '202': 'ROKT Session ID not available',
  '300': 'ROKT unavailable',
  '301': 'ROKT could not be loaded',
  '302': 'ROKT failed to initialize',
  '303': 'Error registering callbacks',
  '309': 'Unkown error during ROKT initialization',
};

type ECode = {
  [index: string]: string;
};

export { ExceptionCodes };
